import React, { useState } from "react";

export const Services = ({ services }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeService, setActiveService] = useState(null);

  const handleReadMore = (service) => {
    setActiveService(service);
    setShowModal(true);
  };

  return (
    <div id="services" className="text-center py-5">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div className="col-10 section-title mx-auto mb-3">
            <h2 className="text-4xl font-bold mb-3 text-gray-800">
              OUR SERVICES
            </h2>
            <p className="max-w-3xl mx-auto" style={{ color: "black" }}>
              Transforming Ideas into Reality! From web design and software
              development to mobile apps, AI, and ethical hacking — we deliver
              cutting-edge solutions that empower businesses to thrive in the
              digital era.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row mt-3 g-4">
          {services.length > 0 ? (
            services.map((item, i) => (
              <div
                key={`${item.title}-${i}`}
                className="col-lg-4 col-md-6 col-sm-12"
              >
                <div className="service-card">
                  <div className="service-inner">
                    {/* FRONT SIDE */}
                    <div className="service-front">
                      <img src={item.image} alt={item.title} />
                      <h4>{item.title}</h4>
                    </div>

                    {/* BACK SIDE */}
                    <div className="service-back">
                      <h4>{item.title}</h4>
                      <p>
                        {item.description.length > 100
                          ? item.description.slice(0, 100) + "..."
                          : item.description}
                      </p>
                      {item.description.length > 100 && (
                        <button
                          style={{
                            backgroundColor: "#6a0dad", // purple
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            padding: "6px 12px",
                            marginTop: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleReadMore(item)}
                        >
                          Read More
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center">Loading services...</p>
          )}
        </div>
      </div>

      {/* Custom Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowModal(false)} // close on outside click
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              maxWidth: "600px",
              width: "90%",
              textAlign: "left",
            }}
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <h3>{activeService?.title}</h3>
            <p>{activeService?.description}</p>
            <button
              style={{
                marginTop: "10px",
                padding: "6px 12px",
                backgroundColor: "#6a0dad",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
